export default (state = null, action = {}) => {
  switch (action.type) {
    case 'FORECAST_OWNER_SET':
      return action.payload;
    default:
      return state;
  }
};
